<template>
  <Content @back="$router.push('/home')">
    <template v-slot:nav_left>
      <div class="nav-btn-box">
        <div class="btn" :class="{ active: 'check' === activeNav }" @click="navChange('check')">评估审核</div>
        <div class="btn" :class="{ active: 'phase' === activeNav }" @click="navChange('phase')">申报评估考核阶段管理</div>
        <div class="btn" :class="{ active: 'performanceGroup' === activeNav }" @click="navChange('performanceGroup')">评估指标组管理</div>
      </div>
    </template>
    <template v-slot:nav_right>
      <template>
        <div v-if="'performanceGroup' === activeNav" class="yioks_btn" @click="isAddPerformanceGroup = true;">添加评估指标组</div>
        <div v-if="'phase' === activeNav" class="yioks_btn" @click="isAddPerformancePhase = true;">添加考核阶段</div>
      </template>
    </template>

    <template v-slot:content_right>
      <div class="com-wrapper" v-if="'performanceGroup' === activeNav">
        <performance-group
          key="performanceGroup"
          :total.sync="total"
          :page.sync="page"
          :pageSize="pageSize"
          :isShowAddDialog.sync="isAddPerformanceGroup"
        ></performance-group>
      </div>
      <div class="com-wrapper" v-if="'phase' === activeNav">
        <performance-phase
          key="phase"
          :total.sync="total"
          :page.sync="page"
          :pageSize="pageSize"
          :isShowAddDialog.sync="isAddPerformancePhase"
        ></performance-phase>
      </div>
      <div class="com-wrapper" v-if="'check' === activeNav">
        <performance-check
          key="check"
          :total.sync="total"
          :page.sync="page"
          :pageSize="pageSize"
          :isShowAddDialog.sync="isAddPerformancePhase"
        ></performance-check>
      </div>
      <Pagination :total="total" :page.sync="page" />
    </template>
  </Content>
</template>

<script>
export default {
  components: {
    Content: () => import("@/components/layout/list"),
    Pagination: () => import("@/components/Pagination"),
    "performance-group": () => import("./components/PerformanceGroup"),
    "performance-phase": () => import("./components/PerformancePhase"),
    "performance-check": () => import("./components/PerformanceCheck"),
  },

  data() {
    return {
      isAddPerformanceGroup: false,
      isAddPerformancePhase: false,
      total: 0,
      page: 0,
      pageSize: 20,
      activeNav: this.$route.query.navName || 'check',
    }
  },

  created() {
    const { navName } = this.$route.query;
    this.$router.replace({
      path: this.$route.path,
      query: {
        navName: navName
      }
    })
  },

  methods: {
    navChange(navName) {
      this.activeNav = navName;
      this.total = 0;
      this.page = 0;
      this.$router.replace({
        path: this.$route.path,
        query: {
          navName: navName
        }
      })
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.nav-btn-box
  display flex
  .btn
    margin-right 20px
    padding 10px 15px
    cursor pointer
    user-select none
    &.active
      background-color $green_color
</style>
